var render = function render(){var _vm=this,_c=_vm._self._c;return _c('default',[_c('div',{staticClass:"cust-motor-wrap"},[_c('motor-finalization-page',{attrs:{"quote-id":_vm.quoteId}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }